import React from 'react';
import { recognizeItems } from '../data/content';
import { Icon } from '../utils/icons';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-163" data-mp="30yj6lyj4ug50">
      <div className="mx-auto max-w-3xl" data-id="element-164" data-mp="2w5yc0usejz0f">
        <div className="text-center" data-id="element-165" data-mp="2w4x1qsj7ngjr">
          <h2 className="font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-166" data-mp="2r7eoipy5uf5y">
            Do You Recognize Yourself in These Situations?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-167" data-mp="2i6qavwcoigtl">
            If you said yes to any of these — this pack is for you.
          </p>
        </div>

        <ul className="mt-9 space-y-3" data-id="element-168" data-mp="2d8ouxkajuxmc">
          {recognizeItems.map(item => <li key={item.text} className="flex items-center gap-4 rounded-2xl bg-white px-5 py-5 sm:px-6" data-id="element-169" data-mp="289c7oyfrnoj8">
              <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-light text-brand" data-id="element-170" data-mp="be6943a3wu5n">
                <Icon name={item.icon} className="h-5 w-5" data-id="element-171" data-mp="3jlc0r58g7z38" />
              </span>
              <span className="text-sm font-medium leading-snug text-ink/80 sm:text-base" data-id="element-172" data-mp="3nmp4n9rzds7i">
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-173" data-mp="39p0ky59ngr41">
          You deserve so much more than that →
        </p>
      </div>
    </section>;
}